export default __webpack_public_path__ + "static/media/5.23cf487a.svg";